
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guide-to-buying-a-used-ev",
      function () {
        return require("private-next-pages/guide-to-buying-a-used-ev.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guide-to-buying-a-used-ev"])
      });
    }
  